import React from 'react';
import { IRifa } from '../../types/rifa';
import RifaSorteada from './RifaSorteada';
import RifaAtiva from './RifaAtiva';
import { RifaStatus } from '../../constants';
import RifaCancelada from './RifaCancelada';

interface Props {
    rifa: IRifa,
    codigoAfiliacao?: string,
    loading?: boolean
}

const RifaPageContent: React.FC<Props> = ({ rifa, codigoAfiliacao, loading }: Props) => {
    if ((rifa.status === RifaStatus.FINALIZADA || rifa.status === RifaStatus.DEMANDA_ESTORNO_MANUAL) && 
        (rifa.motivoReprovacao || !rifa.numeroBilheteGanhador)) {
        // Rifa cancelada ou com meta não atingida
        return <RifaCancelada rifa={rifa} loading={loading} />
    } 
    
    if (rifa.numeroBilheteGanhador || rifa.nomeGanhador) {
        return <RifaSorteada rifa={rifa} loading={loading} />
    }

    return <RifaAtiva rifa={rifa} loading={loading} codigoAfiliacao={codigoAfiliacao} />
}

export default RifaPageContent;